import { render, staticRenderFns } from "./EventCardView.vue?vue&type=template&id=a64da8bc&"
import script from "./EventCardView.vue?vue&type=script&lang=js&"
export * from "./EventCardView.vue?vue&type=script&lang=js&"
import style0 from "./EventCardView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports